import { ElemTypes, IElement } from 'common/interfaces';
import DraggableFlatlist from 'components/DraggableFlatlist';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { FC, memo, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import LayersService from 'services/LayersService';
import {
  groupElemsWhenChildElemTransformStop,
  toggleNestedLayersVisibility,
} from 'store/reducers/elems.slice';

import { IDroppedItem } from '../LayersSidebar.interfaces';
import LayerItem from './LayerItem/LayerItem';

const LayersList: FC = () => {
  const dispatch = useDispatch();

  const elems = useTypedSelector((state) => state.elems.elems);

  const isLayersDragDisabled = useTypedSelector(
    (state) => state.elems.isLayersDragDisabled,
  );
  const isGroupResizeEvent = useTypedSelector(
    (state) => state.common.isMultipleStateUpdateEvent,
  );
  const isLayersRenderDisabled = useTypedSelector(
    (state) => state.elems.isLayersRenderDisabled,
  );

  const [layers, setLayers] = useState<IElement[]>([]);

  const handleDropListItem = useCallback(
    (droppedItem: IDroppedItem): void => {
      LayersService.changeLayerPosition(droppedItem, layers, dispatch);
    },
    [layers, dispatch],
  );

  const onDragStart = useCallback(
    (data): void => {
      const elem = layers.find((item) => item.id === data.draggableId);

      dispatch(groupElemsWhenChildElemTransformStop());

      if (elem && elem.elemType === ElemTypes.GROUP && elem.showNestedLayers) {
        dispatch(toggleNestedLayersVisibility(elem.id));
      }
    },
    [layers, dispatch],
  );

  useEffect(() => {
    if (!isGroupResizeEvent && !isLayersRenderDisabled) {
      const layers = LayersService.transformElemsToLayers(elems);
      setLayers(layers);
    }
  }, [elems, isGroupResizeEvent, isLayersRenderDisabled]);

  const renderLayerItem = useCallback(
    (data) => <LayerItem layerData={data} />,
    [],
  );

  return (
    <div>
      <DraggableFlatlist
        droppableId="list-container"
        list={layers}
        handleDropItem={handleDropListItem}
        ListItem={renderLayerItem}
        isDragDisabled={isLayersDragDisabled}
        onDragStart={onDragStart}
      />
    </div>
  );
};

export default memo(LayersList);
